<script>
  /**
   * Firestore ドキュメントを月別に一覧表示するコンポーネント
   */
  import { DateTime } from 'luxon'

  import { Collection } from '../../modules/sveltefire'

  import LoadingIndicator from '../LoadingIndicator.svelte'
  import GroupBy from '../GroupBy.svelte'
  import TextInput from './inputs/TextInput.svelte'
  import FirebaseInit from './FirebaseInit.svelte'

  export let title // 表示するタイトル
  export let getCollection // 対象のドキュメント コレクションを取得する関数
  export let query // 取得したドキュメントをクエリする関数
  export let key // 取得したドキュメントを グルーピング するキー

  let db // Firestore のインスタンス
  let month = DateTime.local().minus({ month: 1 }).toFormat('yyyy-MM') // 月の初期値を設定
</script>

<FirebaseInit bind:db>
  <h1>{@html title}</h1>

  <!-- 表示する月の選択 -->
  <TextInput name="month" label="表示する月" type="month" bind:value={month} />

  <hr />

  <Collection path={getCollection(db)} query={query(month)} let:data>
    <!-- コレクション 読込中 -->
    <span slot="loading">
      <LoadingIndicator>読込中...</LoadingIndicator>
    </span>

    <!-- エラー表示 -->
    <span slot="fallback">エラーで表示できません...</span>

    <!-- コレクションの表示 -->
    {#if data?.length}
      <GroupBy {key} rows={data} let:id let:index let:filtered>
        <!-- グルーピングの折りたたみ表示 -->
        <details data-testid={`details${index}`}>
          <summary class="panel-heading" data-testid={`summary${index}`}>
            {id ? id : '(未記入)'}
          </summary>
          <!-- 各データ表示部スロット -->
          <slot {id} {index} {filtered} />
        </details>
      </GroupBy>
    {:else}
      <p>記録がありません</p>
    {/if}
  </Collection>
</FirebaseInit>
